import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex align-center justify-start flex-col w-full text-start" }
const _hoisted_2 = {
  key: 0,
  class: "m-s"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Sie sind noch mit keinem Unternehmen verknüpft. Bitten Sie entweder den Inhaber des Accounts Ihrer Unternehmen Sie einzuladen oder erstellen Sie Ihr Unternehmen. ", -1)
const _hoisted_4 = {
  key: 1,
  class: "my-s"
}

import UButton from "@/components/UButton.vue";
import CenteredCard from "@/components/CenteredCard.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import { ref } from "vue";
import CreateCareProviderGroupView from "../views/CreateCareProviderGroupView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoCareProviderGroupCard',
  setup(__props) {

const createCareProviderGroup = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CenteredCard, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!createCareProviderGroup.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(UmanaHeadline, {
                class: "pb-2",
                h: "h1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Unternehmen")
                ]),
                _: 1
              }),
              _hoisted_3,
              _createVNode(UButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (createCareProviderGroup.value = true)),
                class: "mt-s float-right"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Neues Unternehmen erstellen")
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(CreateCareProviderGroupView),
              _createVNode(UButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (createCareProviderGroup.value = false)),
                color: "white",
                class: "float-right mt-xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Abbrechen")
                ]),
                _: 1
              })
            ]))
      ])
    ]),
    _: 1
  }))
}
}

})